/**
 * Chemins internes d’administration — non publiés dans les menus grand public.
 * Ne pas exposer ces URLs dans le footer, la nav mobile, les emails marketing, etc.
 *
 * Sécurité : l’obscurité du path n’est PAS un contrôle d’accès.
 * L’accès réel repose sur ProtectedRoute (adminOnly / requiredRoles) + claims / rôle
 * Firestore côté serveur. MFA ou allowlist IP restent optionnels côté ops.
 */
export const ADMIN_PANEL_PATH = '/cep-gestion-k3m9x2';
export const ADMIN_ROLE_MANAGER_PATH = '/cep-gestion-k3m9x2/roles';

/** Anciennes URLs publiques — redirigées silencieusement vers l’accueil */
export const LEGACY_ADMIN_PATHS = [
  '/admin',
  '/admin-setup',
  '/admin-fix',
  '/admin-role-manager'
];

export default ADMIN_PANEL_PATH;
